import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import createFilter from "redux-persist-transform-filter";

import studentReducer from "./slices/studentSlice";
import questionReducer from "./slices/questionSlice";
import manageReducer from "./slices/manageslice";
import categoryReducer from "./slices/categorySlice";
import branchReducer from "./slices/branchSlice";
import courseReducer from "./slices/courseSlice";
import mockTestSlice from "./slices/mockTestSlice";
import historySlice from "./slices/historyslice";
import studentDashboardSlice from "./slices/studentDashboardSlice";
import finalExamSlice from "./slices/finalExamSlice";
import userReducer from "./slices/userSlice";
import drawingQuestionReducer from "./slices/drawingQuestionSlice";
import studyMaterialReducer from "./slices/studyMaterialSlice";
import studentCourseFilterReducer from "./slices/studentCourseFilterSlice";


const saveExamDataFilter = createFilter("finalExams", ["examData"]);

const rootReducer = combineReducers({
  students: studentReducer,
  questions: questionReducer,
  drawingQuestions: drawingQuestionReducer,
  manages: manageReducer,
  category: categoryReducer,
  branches: branchReducer,
  courses: courseReducer,
  history: historySlice,
  mockTests: mockTestSlice,
  studentDashboard: studentDashboardSlice,
  finalExams: finalExamSlice,
  user: userReducer,
  studyMaterials: studyMaterialReducer,
  studentCourseFilter: studentCourseFilterReducer,
});

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["finalExams", "studentCourseFilter"],
  transforms: [saveExamDataFilter],
  serialize: (data) => {
    try {
      return JSON.stringify(data);
    } catch (error) {
      console.error("Redux persist serialize error:", error);
      return "{}";
    }
  },
  deserialize: (data) => {
    try {
      return JSON.parse(data);
    } catch (error) {
      console.error("Redux persist deserialize error:", error);
      return {};
    }
  },
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);
export default store;
